import { Collapse as MUICollapse, CollapseProps } from '@mui/material';

export { type CollapseProps } from '@mui/material';

export function Collapse(props: CollapseProps) {
  return <MUICollapse {...props} />;
}
